import { Theme } from '@mui/material';

const Chip = (theme: Theme) => {
  return {
  };
};

export default Chip;
